import React from 'react'

import { Label } from '@pb/components'
import { useDispatch } from 'react-redux'

import { splitPhoneNumber } from 'helpers/phoneNumber'

import UpgradeToClubBase from './components/UpgradeToClubBase'
import { operationUpgradeAndUpdateState } from './duck/operations'

const UpgradeToClubFromHubPage: React.FC = () => {
  const dispatch = useDispatch()

  const handleSubmit = (data): any => {
    const { cellPhone: fullNumber, ...rest } = data
    const formData = {
      ...splitPhoneNumber(fullNumber),
      ...rest,
    }
    dispatch(operationUpgradeAndUpdateState(formData))
  }

  return (
    <UpgradeToClubBase
      shouldHideOptionalFields={false}
      shouldShowCancelButton={false}
      subHeadingText={<Label copyKey="hub.register.offer" />}
      onSubmit={handleSubmit}
    />
  )
}

export default UpgradeToClubFromHubPage
